import { MixpanelClient } from '@mathflat/shared/@modules/mixpanel/MixpanelClient'
import { deviceType } from 'react-device-detect'

import { localStorageService } from '@/service/storage.service'
import { envUtils } from '@/utils/envUtils'

import type { EventSchema } from './schema/event.schema'
import type { GlobalEventPropertiesSchema } from './schema/globalEventProperties.schema'
import type { UserPropertiesSchema } from './schema/userProperties.schema'
import { buildTeacherMixpanelConfig, isElectronApp } from './mixpanelConfig'

type MixpanelInstance = ReturnType<typeof MixpanelClient.getMixpanel>

export class TeacherMixpanelClient extends MixpanelClient<EventSchema> {
  constructor() {
    super(
      import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN,
      buildTeacherMixpanelConfig({
        debug: !!localStorageService.getItem('MIXPANEL_DEBUG'),
        isLive: envUtils.isLive,
        isElectronApp: isElectronApp(),
      }),
      {
        globalPropertiesVersion: 'v1.0@2025-07-30',
        userPropertiesVersion: 'v1.0@2025-07-30',
      },
    )
  }

  override initialize() {
    super.initialize(deviceType)
    // 여기서 globalProperty 버전관리하기
    // 버저닝 시작하기 이전의 값들은 삭제
    if (!this.getEventProperty('globalPropertiesVersion')) {
      this.unregister('academy')
      this.unregister('coupons')
      this.unregister('teacher')
    }

    // TODO: 잘못 들어간 대량의 데이터 삭제
    // 사실은 mixpanel에 api를 쏴서 전역적으로 삭제해야하는데
    // 임시로 클라이언트에서 조치하려면 이렇게 해야함 (실제 실행한 적 없음)
    // this.removeUserProperty(['columnDefs', '_subscribeItems', 'statusHistories'])
  }

  override setGlobalEventProperty(props: Partial<GlobalEventPropertiesSchema>) {
    super.setGlobalEventProperty(props)
  }

  override track<K extends Extract<keyof EventSchema, string>>(
    eventName: K,
    properties?: EventSchema[K] extends never ? never : EventSchema[K],
    optionsOrCallback?: Parameters<MixpanelInstance['track']>[2],
    callback?: Parameters<MixpanelInstance['track']>[3],
  ) {
    super.track(eventName, properties, optionsOrCallback, callback)
  }

  override setUserProperty(props: Partial<UserPropertiesSchema>) {
    super.setUserProperty(props)
  }
}

export const mixpanelClient = new TeacherMixpanelClient()
